"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const roomFilterState_1 = require("./roomFilterState");
const react_i18next_1 = require("react-i18next");
const ToggleButtonGroup_1 = __importDefault(require("@mui/material/ToggleButtonGroup"));
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
const Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
function default_1({ isUserInfoReady, isFetching, }) {
    const [payformFilter, setPayformFilter] = (0, recoil_1.useRecoilState)(roomFilterState_1.payformFilterState);
    const onPayformFilterChange = (_, isPayform) => {
        !isFetching && isPayform !== null && setPayformFilter(isPayform);
    };
    const roomTypeFilter = (0, recoil_1.useRecoilValue)(roomFilterState_1.roomTypeFilterState);
    const isRoomTypeRecent = roomTypeFilter === '';
    const { name: categoryFilterName } = (0, recoil_1.useRecoilValue)(roomFilterState_1.categoryFilterState);
    const CategoryFilterName = () => {
        if (isRoomTypeRecent && !!categoryFilterName) {
            return (0, jsx_runtime_1.jsxs)("span", { children: ["(", categoryFilterName, ")"] });
        }
        else
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    if (!isUserInfoReady)
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', columnGap: '8px' } }, { children: [(0, jsx_runtime_1.jsx)(Skeleton_1.default, { variant: "rectangular", animation: "wave", sx: { width: '53px', height: '32px', borderRadius: '8px' } }), (0, jsx_runtime_1.jsx)(Skeleton_1.default, { variant: "rectangular", animation: "wave", sx: { width: '108px', height: '32px', borderRadius: '8px' } })] })));
    return ((0, jsx_runtime_1.jsxs)(ToggleButtonGroup_1.default, Object.assign({ "aria-label": "main_rooms_payform_filter", exclusive: true, value: payformFilter, onChange: onPayformFilterChange, sx: {
            display: 'flex',
            columnGap: '8px',
            borderRadius: 0,
            '.MuiToggleButton-root': {
                flexShrink: 0,
                height: '32px',
                padding: '0 12px',
                border: '1px solid var(--gray-10) !important',
                borderRadius: '8px !important',
                bgcolor: 'var(--white) !important',
                color: 'var(--gray-80)',
                lineHeight: '15px',
                fontSize: '15px',
                fontWeight: 'normal',
            },
            '.Mui-selected': {
                border: '0 !important',
                bgcolor: 'var(--gray-80) !important',
                color: 'var(--white) !important',
            },
        } }, { children: [(0, jsx_runtime_1.jsxs)(ToggleButton_1.default, Object.assign({ "aria-label": "all rooms", value: false }, { children: [t('전체'), (0, jsx_runtime_1.jsx)(CategoryFilterName, {})] })), (0, jsx_runtime_1.jsxs)(ToggleButton_1.default, Object.assign({ "aria-label": "payform only", value: true }, { children: [t('카드결제'), (0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/images/payform_gold_card.webp`, css: { width: '22px', height: '14px', marginLeft: '6px' } })] }))] })));
}
exports.default = default_1;
